
export enum UploadType {
  Clients = 1,
  Employees = 2,
  PettyCash = 3,
  Suppliers = 4
}
